module.exports = __webpack_public_path__ + "img/intro_tab1_4.70a7c820.png";